<div class="container">
  <div
    class="vertical-bar"
    [ngClass]="item.state"
    *ngFor="let item of data"
    [style]="'height: ' + (400 * item.number) / data.length + 'px;'"
  ></div>
</div>
